/* eslint-disable @typescript-eslint/unbound-method */
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { BenefitsChoiceType } from '@/features/benefitsChoice/types';

export const benefitsChoiceAdapter = createEntityAdapter<BenefitsChoiceType>();

/** Слайс стейта, хранящий выбранные пользователем выгоды для каждого автомобиля. */
export const benefitsChoiceSlice = createSlice({
  name: 'benefitsChoice',
  initialState: benefitsChoiceAdapter.getInitialState(),
  reducers: {
    setBenefitsChoice: benefitsChoiceAdapter.setOne,
    resetBenefitsChoice: benefitsChoiceAdapter.removeOne,
  },
});

export default benefitsChoiceSlice.reducer;
